import { Injector } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '@services/auth.service';
import { CompanySettingService } from '@services/company-setting.service';

// MSALInstanceFactory reads clientId / tenantId from CompanySettingService
// synchronously. If the company hasn't been fetched yet, it falls back to
// 'invalid' placeholders and Azure later rejects auth with AADSTS900023. To
// avoid that, resolve the company setting first (bounded by a short timeout so
// bootstrap can never hang) — then pull MsalService out of the injector to
// trigger the factory with the real credentials in place.
const COMPANY_SETTINGS_TIMEOUT_MS = 5000;

export function msalInitializer(injector: Injector) {
  return async (): Promise<void> => {
    const authService = injector.get(AuthService);
    if (authService.hasAuthCookie()) {
      const companySettingService = injector.get(CompanySettingService);
      await firstValueFrom(
        companySettingService.current().pipe(
          timeout(COMPANY_SETTINGS_TIMEOUT_MS),
          catchError(() => of(null)),
        ),
      );
    }

    const msalService = injector.get(MsalService);
    await msalService.instance.initialize();
  };
}
